import React from 'react';

interface Props {
  value: string | number;
  onChange: (value: string) => void;
  type?: 'text' | 'number';
  placeholder?: string;
  className?: string;
  style?: React.CSSProperties;
  'aria-label'?: string;
}

/** Inline table cell editor — no MUI focus ring, prototype-native feel */
export const TmCellInput: React.FC<Props> = ({
  value, onChange, type = 'text', placeholder, className = '', style, 'aria-label': ariaLabel,
}) => (
  <input
    type={type}
    className={`tm-cell-inp ${className}`.trim()}
    value={value}
    placeholder={placeholder}
    onChange={e => onChange(e.target.value)}
    aria-label={ariaLabel}
    style={style}
  />
);
